import { z } from 'zod';

export const ValidateWordsExistenceSchema = z.object({
  words: z
    .array(z.string().min(1))
    .min(1, 'At least one word must be provided for validation'),
});

export type IValidateWordsExistenceDto = z.infer<
  typeof ValidateWordsExistenceSchema
>;
